var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DEMO_TIME_MANAGEMENT_LABEL_IDS, getDemoActivityLabelName } from '@web/lib/demo/data/labels';
import { diffComparisonType } from '@workalizer/shared/types';
import { formatDuration, getPercentageDiff, randomInt } from '@workalizer/shared/utils';
var comparisonCountFromDiffString = function (current, diffString) {
    var pct = Number(diffString.replace('%', '').replace('+', ''));
    if (pct === 0) {
        return current;
    }
    return Math.round(current / (1 + pct / 100));
};
var buildPrevPeriodDiff = function (current, diffString) {
    return getPercentageDiff(comparisonCountFromDiffString(current, diffString), current);
};
var buildTeamAvgDiff = function (current, diffString) {
    var pct = Number(diffString.replace('%', '').replace('+', ''));
    var teamAvg = pct === 0 ? current : Math.round(current / (1 + pct / 100));
    var diff = getPercentageDiff(teamAvg, current, {
        comparisonType: diffComparisonType.teamAverage
    });
    return __assign(__assign({}, diff), { comparisonValueDisplay: String(teamAvg) });
};
var buildCountDurationMetric = function (count, durationSeconds, diffs) { return ({
    count: count,
    duration: formatDuration(durationSeconds, 'seconds'),
    prevPeriodDiff: buildPrevPeriodDiff(count, diffs.prev),
    teamAvgDiff: buildTeamAvgDiff(count, diffs.team)
}); };
var buildCountMetric = function (count, diffs) { return ({
    count: count,
    prevPeriodDiff: buildPrevPeriodDiff(count, diffs.prev),
    teamAvgDiff: buildTeamAvgDiff(count, diffs.team)
}); };
var workingTimeAllocationRowConfigs = [
    {
        meetings: { prev: '+17%', team: '+8%' },
        documents: { prev: '0%', team: '-22%' },
        chatMessages: { count: 11, diffs: { prev: '-63%', team: '-56%' } },
        events: { count: 0, diffs: { prev: '+10%', team: '+15%' } }
    },
    {
        meetings: { prev: '+17%', team: '-12%' },
        documents: { prev: '-100%', team: '-45%' },
        chatMessages: { count: 2, diffs: { prev: '-94%', team: '-36%' } },
        events: { count: 0, diffs: { prev: '+5%', team: '+20%' } }
    },
    {
        meetings: { prev: '+17%', team: '+5%' },
        documents: { prev: '0%', team: '-30%' },
        chatMessages: { count: 622, diffs: { prev: '-3%', team: '-14%' } },
        events: { count: 0, diffs: { prev: '+46%', team: '+8%' } }
    }
];
var buildWorkingTimeAllocationRow = function (config) {
    var meetingsCount = randomInt(5, 25);
    var meetingsDurationSeconds = randomInt(1800, 7200);
    var chatDurationSeconds = Math.ceil(config.chatMessages.count / 5) * 180;
    return {
        meetings: buildCountDurationMetric(meetingsCount, meetingsDurationSeconds, config.meetings),
        documents: buildCountDurationMetric(0, 0, config.documents),
        chatMessages: buildCountDurationMetric(config.chatMessages.count, chatDurationSeconds, config.chatMessages.diffs),
        events: buildCountMetric(config.events.count, config.events.diffs)
    };
};
export var workingTimeAllocationByLabel = function (_input) {
    var labelIds = DEMO_TIME_MANAGEMENT_LABEL_IDS;
    return labelIds.map(function (labelId, index) { return (__assign({ labelId: labelId, labelName: getDemoActivityLabelName(labelId) }, buildWorkingTimeAllocationRow(workingTimeAllocationRowConfigs[index]))); });
};
